import SearchFormController from "./search_form_controller"
import Logger from '../lib/logger'

/**
 * Provider Search Controller - Extends search form controller with provider-specific functionality
 */
export default class extends SearchFormController {
  static targets = [
    "nameField", "stateField", "cityField", "pendingCheck", "noCoverageCheck",
    "notActiveCheck", "renewCheck", "sortField"
  ]

  connect() {
    super.connect()
    this.entityTypeValue = 'provider'
  }

  convertToSearchParam(fieldName, value) {
    // Provider-specific field mappings
    if (fieldName.includes('name')) {
      return { key: 'q[name_cont]', value: value }
    }
    if (fieldName.includes('state')) {
      return { key: 'q[states_id_eq]', value: value }
    }
    if (fieldName.includes('city')) {
      return { key: 'q[cities_id_in]', value: value }
    }
    if (fieldName.includes('sort')) {
      return { key: 'q[s]', value: value }
    }
    if (fieldName.includes('pending')) {
      return { key: 'pending', value: value ? '1' : '0' }
    }
    if (fieldName.includes('no_coverage')) {
      return { key: 'no_coverage', value: value ? '1' : '0' }
    }
    if (fieldName.includes('not_active')) {
      return { key: 'not_active', value: value ? '1' : '0' }
    }
    if (fieldName.includes('renew')) {
      return { key: 'renew', value: value ? '1' : '0' }
    }
    
    // Generic mapping
    return { key: `q[${fieldName}_cont]`, value: value }
  }

  // Handle city selection from autocomplete
  handleCitySelection() {
    Logger.debug('City selected, ready for search')
    this.performSearch()
  }

  // Advanced search methods
  searchByStatus(status) {
    // Quick status filter
    if (this.hasNotActiveCheckTarget) {
      this.notActiveCheckTarget.checked = (status === 'inactive')
    }
    this.debounceSearch()
  }

  searchByCoverage(hasCoverage) {
    // Quick coverage filter
    // Was `this.notActiveCheckTarget.checked` — a copy-paste from searchByStatus() above;
    // this method presence-checks noCoverageCheckTarget but was toggling the wrong checkbox
    // (notActiveCheck), leaving the actual "no coverage" filter untouched.
    if (this.hasNoCoverageCheckTarget) {
      this.noCoverageCheckTarget.checked = !hasCoverage
    }
    this.performSearch()
  }

  getCleanUrl() {
    return '/providers'
  }
}
